<main class="page container-fluid">
  <!-- User card -->
  <section class="card border-0 shadow-sm user-card">
    <div class="card-body d-flex align-items-center gap-3 flex-wrap">
      <div class="user-block d-flex align-items-center gap-3">
        <div class="user-card__avatar">{{ user().initials }}</div>
        <div>
          <p class="user-card__name mb-0">{{ user().name }}</p>
          <p class="user-card__meta mb-0">{{ 'Project Engineer' }}</p>
        </div>
      </div>

      @if (incomingB2bState() !== 'none' && incomingB2bRequest(); as incomingRequest) {
        <span class="badge user-b2b-badge">B2B</span>
        <div class="user-block user-block--b2b d-flex align-items-center gap-3">
          <div class="user-card__avatar">{{ initials(incomingRequest.name) }}</div>
          <div class="b2b-info">
            <div class="b2b-name-row">
              <p class="user-card__name mb-0">{{ incomingRequest.name }}</p>
              @if (incomingB2bState() === 'pending') {
                <span class="badge rounded-pill status status--pending">● Pending</span>
              }
              @if (incomingB2bState() === 'active') {
                <span class="badge rounded-pill status status--active">● Active</span>
              }
            </div>
            <p class="user-card__meta mb-0">{{ 'Project Engineer' }}</p>
          </div>

          @if (incomingB2bState() === 'pending' && !incomingRequest.isRequester) {
            <div class="b2b-actions">
              <button type="button" class="btn b2b-send-btn" (click)="askConfirmIncomingRequest()">Confirm request</button>
              <button type="button" class="btn b2b-cancel-btn" (click)="askRejectIncomingRequest()">Reject</button>
            </div>
            @if (incomingActionError()) {
              <p class="b2b-error mb-0" role="alert">{{ incomingActionError() }}</p>
            }
          }
          @if (incomingB2bState() === 'pending' && incomingRequest.isRequester) {
            <button class="user-remove" type="button" (click)="askCancelOwnB2bRequest()" aria-label="Cancel B2B request">×</button>
          }
          @if (incomingB2bState() === 'active') {
            <button class="user-remove" type="button" (click)="askCancelOwnB2bRequest()" aria-label="Remove B2B user">×</button>
          }
        </div>
      } @else if (!b2bUser()) {
        <div class="user-directory">
          <input
            id="userDirectory"
            class="user-directory__select"
            [ngModel]="selectedUserId()"
            (ngModelChange)="addUserById($event)"
            placeholder="Select b2b user..."
            autocomplete="off"
            [matAutocomplete]="b2bUserOptions"
            #b2bTrigger="matAutocompleteTrigger"
            (focus)="openB2BOptions(b2bTrigger)"
            (click)="openB2BOptions(b2bTrigger)"
            (blur)="onB2BBlur()"
          />
          <mat-autocomplete #b2bUserOptions="matAutocomplete">
            @for (userItem of filteredAvailableUsers(); track userItem.id) {
              <mat-option [value]="userItem.name + ' · ' + userItem.department">{{ userItem.name }} · {{ userItem.department }}</mat-option>
            }
          </mat-autocomplete>
        </div>
      } @else {
        <span class="badge user-b2b-badge">B2B</span>
        <div class="user-block user-block--b2b d-flex align-items-center gap-3">
          <div class="user-card__avatar">{{ initials(b2bUser()!.name) }}</div>
          <div class="b2b-info">
            <div class="b2b-name-row">
              <p class="user-card__name mb-0">{{ b2bUser()!.name }}</p>
              @if (b2bRequestPending()) {
                <span class="badge rounded-pill status status--pending">● Pending</span>
              }
            </div>
            <p class="user-card__meta mb-0">{{ b2bUser()!.role || 'Project Engineer' }}</p>
          </div>
          @if (!b2bRequestPending()) {
            <div class="b2b-actions">
              <button type="button" class="btn b2b-send-btn" [disabled]="b2bRequestSending()" (click)="sendB2BRequest()">{{ b2bRequestSending() ? 'Sending...' : 'Send request' }}</button>
              <button type="button" class="btn b2b-cancel-btn" (click)="clearB2BUser()">Cancel</button>
            </div>
            @if (b2bRequestError()) {
              <p class="b2b-error mb-0" role="alert">{{ b2bRequestError() }}</p>
            }
          } @else {
            <button class="user-remove" type="button" (click)="askRemoveB2BUser()" aria-label="Remove B2B user">×</button>
          }
        </div>
      }

      <span class="badge rounded user-card__sso ms-auto">● Signed in via SSO</span>
    </div>
  </section>

  <!-- B2B Remove Confirmation Modal -->
  @if (showRemoveConfirm()) {
    <div class="modal-backdrop" animate.enter="modal-backdrop-enter" animate.leave="modal-backdrop-leave" (click)="cancelRemoveB2BUser()"></div>
    <div class="confirm-modal" animate.enter="confirm-modal-enter" animate.leave="confirm-modal-leave">
      <p class="confirm-modal__title">Remove B2B User</p>
      <p class="confirm-modal__message">Are you sure you want to remove <strong>{{ b2bUser()?.name }}</strong> as B2B user?</p>
      <div class="confirm-modal__actions">
        <button type="button" class="btn-confirm btn-confirm--cancel" (click)="cancelRemoveB2BUser()">Cancel</button>
        <button type="button" class="btn-confirm btn-confirm--confirm" (click)="confirmRemoveB2BUser()">Remove</button>
      </div>
    </div>
  }

  <!-- Cancel incoming/active B2B Confirmation Modal -->
  @if (showCancelB2bConfirm() && incomingB2bRequest(); as incomingRequest) {
    <div class="modal-backdrop" animate.enter="modal-backdrop-enter" animate.leave="modal-backdrop-leave" (click)="cancelCancelOwnB2bRequest()"></div>
    <div class="confirm-modal" animate.enter="confirm-modal-enter" animate.leave="confirm-modal-leave">
      <p class="confirm-modal__title">Remove B2B User</p>
      <p class="confirm-modal__message">Are you sure you want to remove <strong>{{ incomingRequest.name }}</strong> as B2B user?</p>
      <div class="confirm-modal__actions">
        <button type="button" class="btn-confirm btn-confirm--cancel" (click)="cancelCancelOwnB2bRequest()">Cancel</button>
        <button type="button" class="btn-confirm btn-confirm--confirm" (click)="cancelOwnB2bRequest()">Remove</button>
      </div>
    </div>
  }

  @if (pendingAction() && incomingB2bRequest(); as incomingRequest) {
    <div class="modal-backdrop" animate.enter="modal-backdrop-enter" animate.leave="modal-backdrop-leave" (click)="cancelPendingAction()"></div>
    <div class="confirm-modal" animate.enter="confirm-modal-enter" animate.leave="confirm-modal-leave">
      <p class="confirm-modal__title">
        {{ pendingAction() === 'confirm' ? 'Confirm B2B request' : 'Reject B2B request' }}
      </p>
      <p class="confirm-modal__message">
        @if (pendingAction() === 'confirm') {
          Are you sure you want to confirm the B2B request from <strong>{{ incomingRequest.name }}</strong>?
        } @else {
          Are you sure you want to reject the B2B request from <strong>{{ incomingRequest.name }}</strong>?
        }
      </p>
      <div class="confirm-modal__actions">
        <button type="button" class="btn-confirm btn-confirm--cancel" (click)="cancelPendingAction()">Cancel</button>
        <button type="button" class="btn-confirm btn-confirm--confirm" [disabled]="incomingActionSending()" (click)="confirmPendingAction()">
          {{ incomingActionSending() ? 'Saving...' : (pendingAction() === 'confirm' ? 'Confirm' : 'Reject') }}
        </button>
      </div>
    </div>
  }

  <!-- Toolbar -->
  <div class="my-3 toolbar-row">
    <h1 class="toolbar__title mb-0">My CE Requests</h1>
    <div class="toolbar-actions">
      <div class="toolbar-search-block">
        <div class="toolbar-search-row">
          <div class="search-wrapper">
            <mat-icon class="search-icon">search</mat-icon>
            <input
              class="search-input"
              type="search"
              placeholder="Search estimate or project..."
              [ngModel]="search()"
              (ngModelChange)="onSearchInputChange($event)"
              (focus)="onSearchInputFocus()"
            />
            @if (searchFieldDropdownOpen()) {
              <div class="requests-search-field-dropdown" (click)="$event.stopPropagation()">
                <p class="requests-search-field-dropdown__title mb-2">Select search field</p>
                @if (!availableSearchFieldOptions().length) {
                  <p class="requests-search-field-dropdown__empty mb-0">All fields are already selected</p>
                } @else {
                  @for (option of availableSearchFieldOptions(); track option.key) {
                    <button
                      type="button"
                      class="requests-search-field-dropdown__item"
                      (click)="addSearchToken(option.key, $event)"
                    >
                      {{ option.label }}
                    </button>
                  }
                }
              </div>
            }
          </div>
          <button type="button" class="btn requests-search-btn" (click)="onSearchClick()">Search</button>
          <button type="button" class="btn btn-primary text-nowrap cta cta--toolbar" (click)="createRequest()">
            + Create New CE Request
          </button>
        </div>
        @if (searchTokens().length) {
          <div class="requests-search-tokens">
            @for (token of searchTokens(); track token.key + ':' + token.value; let i = $index) {
              <span class="requests-search-token">
                <span class="requests-search-token__label">{{ token.label }}:</span>
                <span class="requests-search-token__value">{{ token.value }}</span>
                <button
                  type="button"
                  class="requests-search-token__remove"
                  (click)="removeSearchToken(i)"
                  aria-label="Remove search token"
                >
                  ×
                </button>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Requests table -->
  <div class="card border-0 shadow-sm requests-table-card">
    <table class="table table-hover align-middle mb-0 ce-table">
      <thead>
        <tr>
          <th>Estimate Number</th>
          <th>Project Title</th>
          <th>
            <button type="button" class="date-filter-trigger" [class.is-active]="hasAppliedDateFilters()" (click)="toggleDateFilter($event)">
              CE Request Date
            </button>
            @if (dateFilterOpen()) {
              <div class="date-filter-dropdown" (click)="$event.stopPropagation()">
                <label class="date-filter-field">
                  <span>From</span>
                  <input
                    type="date"
                    [ngModel]="selectedStartDate()"
                    (ngModelChange)="selectedStartDate.set($event || '')"
                  />
                </label>
                <label class="date-filter-field">
                  <span>To</span>
                  <input
                    type="date"
                    [ngModel]="selectedEndDate()"
                    (ngModelChange)="selectedEndDate.set($event || '')"
                  />
                </label>
                <div class="date-filter-actions">
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearDateFilters()">Clear</button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="applyDateFilters()">Search</button>
                </div>
              </div>
            }
          </th>
          <th>CE Engineer</th>
          <th>ES Title</th>
          <th>
            <button type="button" class="status-filter-trigger" [class.is-active]="hasAppliedStatusFilters()" (click)="toggleStatusFilter($event)">
              Status
            </button>
            @if (statusFilterOpen()) {
              <div class="status-filter-dropdown" (click)="$event.stopPropagation()">
                @for (status of statusFilterOptions; track status) {
                  <label class="status-filter-option">
                    <input type="checkbox" [checked]="isStatusFilterSelected(status)" (change)="toggleStatusFilterValue(status)" />
                    <span>{{ status }}</span>
                  </label>
                }
                <div class="status-filter-actions">
                  <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearStatusFilters()">Clear</button>
                  <button type="button" class="btn btn-sm btn-primary" (click)="applyStatusFilters()">Search</button>
                </div>
              </div>
            }
          </th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        @if (projectsLoading()) {
          <tr>
            <td class="text-center text-secondary py-5" colspan="7">
              Loading...
            </td>
          </tr>
        } @else {
          @for (project of filteredRequests(); track project.id) {
            <tr>
              <td class="fw-bold cell--estimate">{{ project.estimateNumber || '-' }}</td>
              <td>{{ project.projectTitle }}</td>
              <td>{{ project.submittedDate ? (project.submittedDate | date: 'yyyy-MM-dd') : '-' }}</td>
              <td>{{ project.tcoEstimator || '-' }}</td>
              <td>{{ project.estimateTitle || '-' }}</td>
              <td>
                <span [class]="'badge rounded-pill ' + statusClass(projectStatusLabel(project.projectStatusType))">
                  ● {{ projectStatusLabel(project.projectStatusType) }}
                </span>
              </td>
              <td>
                <button type="button" class="btn btn-link p-0 link" (click)="viewProject(project)">
                  View
                </button>
              </td>
            </tr>
          } @empty {
            <tr>
              <td class="text-center text-secondary py-5" colspan="7">
                No CE requests match your search.
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <!-- Pagination (ng-bootstrap NgbPagination) -->
  <footer class="d-flex flex-wrap align-items-center justify-content-between gap-3 mt-3 pager">
    <span class="pager__summary">
      Showing {{ filteredTotal() ? (currentPage() - 1) * pageSize + 1 : 0 }}–{{ filteredTotal() ? (currentPage() - 1) * pageSize + filteredRequests().length : 0 }} of {{ filteredTotal() }} requests
    </span>
    <ngb-pagination
      [collectionSize]="filteredTotal()"
      [pageSize]="pageSize"
      [page]="currentPage()"
      (pageChange)="currentPage.set($event)"
      [maxSize]="5"
      [boundaryLinks]="false"
    />
  </footer>
</main>
